import { Box, Typography } from "@dealer-center/core-components";

export const ContactsPage = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h6">Contacts</Typography>
    <Typography sx={{ color: "text.secondary", mt: 1 }} variant="body-md">
      TODO: implement Contacts
    </Typography>
  </Box>
);
